import { computed } from "vue";
import { useDocumentStore } from "../store/document";

export function useDiskoDocumentReady() {
  const document = useDocumentStore();
  return computed(() => document.state === "ready");
}
